import { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "@/api";
import PageHero from "@/components/tex/PageHero";
import { staggerContainer, staggerItem } from "@/components/tex/PageTransition";

export default function TeamPage() {
  const { company } = useOutletContext();
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    document.title = "Team — Texcheme";
    window.scrollTo(0, 0);
    api
      .getTeam()
      .then(setTeam)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <PageHero
        eyebrow="Our team"
        title="The people behind your deliveries"
        lead="A small, hands-on team where the person who commits to a dispatch date is the person who owns it."
      />

      <section className="panel" data-testid="team-list">
        <div className="wrap">
          {loading && <p className="note">Loading team…</p>}
          {error && <p className="note">Couldn&apos;t load the team right now. {error}</p>}
          {!loading && !error && (
            <motion.div
              className="team-grid"
              variants={staggerContainer}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.15 }}
            >
              {team.map((m, i) => (
                <motion.div
                  className="team-card"
                  key={i}
                  data-testid={`team-member-${i}`}
                  variants={staggerItem}
                  whileHover={{ y: -3, transition: { duration: 0.2 } }}
                >
                  <div className="team-avatar">{m.initials}</div>
                  <h3>{m.name}</h3>
                  <div className="team-role">{m.role}</div>
                  <p>{m.bio}</p>
                </motion.div>
              ))}
            </motion.div>
          )}
          <p className="note team-note">
            Profiles shown are placeholders — replace with real names, roles and photos before launch.
          </p>
        </div>
      </section>

      <section className="panel dark cta-panel" data-testid="team-cta">
        <div className="wrap cta-panel-inner">
          <div>
            <h2>Talk to the right person directly</h2>
            <p>Sales for quotes and standing orders, QC for COA and grade questions.</p>
          </div>
          <Link to="/contact" className="btn btn-brand">Contact us</Link>
        </div>
      </section>
    </>
  );
}
